import { TagWithEllipsis } from '@/components/tag/tag-with-ellipsis';
import { useProjectFiles } from '../project-files/use-project-files.query';
import { SkeletonBox } from '@/components/skeleton/skeleton-box';
import { Inline } from '@/ui/line/line';
import { useProjectFilesActions } from '../project-files/use-project-files-actions';

export const ProjectFilesTags = () => {
  const { data, isLoading, isFetched } = useProjectFiles();

  const { downloadProjectFile } = useProjectFilesActions();

  if (isLoading) {
    return <SkeletonBox width="150px" height="20px" />;
  }

  if (isFetched && data?.length === 0) {
    return null;
  }

  const newestFiles = data?.slice(0, 4);

  return (
    <Inline justifyContent="flex-start">
      {newestFiles?.map(file => (
        <TagWithEllipsis
          key={file.id}
          text={file.name}
          variant="gray"
          startIcon="Attach"
          onClick={() => downloadProjectFile(file, 'preview')}
        />
      ))}
    </Inline>
  );
};
